import { all, allArabic, sunLetters, wordEndTranscription, allConsonantsTranscription, typeDirectToArabicArray, arabicDirectFromTypeArray, transcriptionInputArray, transcriptionArray, transcriptionSpecialInputArray, transcriptionSpecialArray, transcriptionFinalVowelsInputArray, transcriptionFinalVowelsArray } from "./consts";


function replaceOccurrences(s: string | undefined, oldArray: (RegExp | string)[], newArray: string[]): string {
    // NOTE : old function name Ersetzen
    // Replaces all occurrences of entries in oldArray with the corresponding terms in newArray in a string s
    // Optimizations made:

    // Combined the if statement with the return statement to make the code more concise.
    // Used a regular expression (RegExp) with the 'g' flag for global replacement, eliminating the need for a while loop.
    // Removed the unnecessary check (s.replace(oldArray[i], newArray[i]) !== s) since the regular expression with the 'g' flag handles global replacement in a single call.
    // Changed the return type to string | null to match the input type of the parameter s.
    if (!s) {
        return "";
    }

    for (let i = 0; i < oldArray.length; i++) {
        const regex = new RegExp(oldArray[i], 'g');
        s = s.replace(regex, newArray[i]);
    }

    return s;
}

function replaceString(s: string, altArray: string[], newArray: string[]): string {
    // NOTE : old function name ErsetzenString
    // Replaces all regular expressions in AltArray with the corresponding ones in NeuArray in a string s.
    // The entries in AltArray are preprocessed, where:
    //   &b (usually: word end) is converted to "no Arabic letter (in transcription or Arabic)"
    //   &S : is converted to "Sun letter" (in transcription)
    //   &y : is converted to a letter (transcription or Arabic)
    //   &W : is converted to word end (in transcription)
    // Optimizations made:

    // Changed the function name ErsetzenString to replaceString.
    // Adjusted parameter names to s, altArray, and newArray.
    // Used let instead of var for loop variables.
    // Removed the compile method, which is deprecated. Instead, directly create a new RegExp object with the pattern and modifiers.
    // Replaced the deprecated search and replace methods with the more standard indexOf and split methods.
    // Updated comments to English.
    const patternRawArray = ['&b', '&S', '&W', '&K', '&y'];
    const patternFineArray = [
        '[^' + all + allArabic + '/' + ']',      // &b
        '[' + sunLetters + ']',                      // &S
        '[' + wordEndTranscription + ']',            // &W
        '[' + allConsonantsTranscription + ']',      // &K
        '[' + all + allArabic + ']'               // &y
    ];

    s = '¡' + s + '¡';  // Mark the beginning and end, this appears in ___WordEndTranscription

    for (let i = 0; i < altArray.length; i++) {
        let pattern = altArray[i];

        for (let j = 0; j < patternRawArray.length; j++) {
            while (pattern.search(patternRawArray[j]) !== -1 && pattern.replace(patternRawArray[j], patternFineArray[j]) !== pattern) {
                pattern = pattern.replace(patternRawArray[j], patternFineArray[j]);
            }
        }

        const regExpObject = new RegExp(pattern, '');  // Convert string to RegExp, "" are the modifiers (g = greedy, etc.)

        while (s.search(regExpObject) !== -1 && s.replace(regExpObject, newArray[i]) !== s) {
            s = s.replace(regExpObject, newArray[i]);
        }
    }

    while (s.search(/¡/) !== -1 && s.replace(/¡/, '') !== s) {
        s = s.replace(/¡/, '');
    }

    return s;
}


function correctDiphthongs(text: string): string | undefined {
    // NOTE : old function name is DiphtongeKorrigieren
    // Corrects the "wrong" input of diphthongs

    const wrongDiphthongArray = [
        /au([^-])/, /ai([^-])/,
        /a-i-/, /a-u-/
    ];

    const correctDiphthongArray = [
        'aw$1', 'ay$1',
        'a-y', 'a-w'
    ];

    const result = replaceOccurrences(text, wrongDiphthongArray, correctDiphthongArray);
    return result;
}

function enterArabicDirectly(text: string): string {

    // NOTE : old function is EintippenArabischDirekt
    return replaceString(text, typeDirectToArabicArray, arabicDirectFromTypeArray);
}

function convertToTranscription(input: string, removeFinalVowels: boolean): string {
    // NOTE : old function name is EintippenUmschrift
    let text = correctDiphthongs(input); // Correct diphthongs 'ai' and 'au' in the input to 'ay' and 'aw'

    text = replaceOccurrences(text, transcriptionInputArray, transcriptionArray);

    const assimilationArray = [
        '(&b)al([^-])', // 1
        '([^l][iu])l\\-', // 2. bil-kita-b
        '(li)l\\-', // 3. lil-kita-b
        '(li)_l\\-', // 3b. li_l-kita-b
        '_l\\-', // 4. bi_l-kita-b
        '([^l][iu])al\\-', // 5. bial-kita-b
        '([^l][iu])_al\\-', // 6. bi_al-kita-b
        'Ä', // Convert Ä at the end back to Alif
        'ł'
    ];

    const assimilationReplacementArray = [
        '$1Äł-$2',
        '$1_Äł-', // 2. bilkita-b to bi_al-kita-b
        '$1_ł-', // 3. lil-kita-b to li_l-kita-b
        '$1_ł-', // 3b. lil-kita-b to li_l-kita-b
        '_Äł-', // 4. bi_l-kita-b to bi_al-kita-b
        '$1_Äł-', // 5. bilkita-b to bial-kita-b
        '$1_Äł-', // 6. bilkita-b to bial-kita-b
        'a',
        'l'
    ];

    text = replaceString(text, assimilationArray, assimilationReplacementArray);
    text = replaceString(text, transcriptionSpecialInputArray, transcriptionSpecialArray);

    if (removeFinalVowels)
        text = replaceString(text, transcriptionFinalVowelsInputArray, transcriptionFinalVowelsArray);

    return text;
}
export function processRefreshArabicInputLemmas(newInput: string) {
    return enterArabicDirectly(newInput);
}

export function processRefreshRomanizationInputLemmas(newInput: string) {
    return convertToTranscription(newInput, false);
}
/*function refreshInputLemmas (newInput:string)
// entfernt den Inhalt aus nicht aktiven Such-Edits (Deutsch, Umschrift oder Arabisch)
// und löst (falls Enter gedrückt wird), das Submit-Event des Formulars aus
{
        document.getElementById('eingabeSucheEdit').value = EintippenUmschrift(document.getElementById('eingabeSucheEdit').value);;
        document.getElementById('eingabeSucheArabischEdit').value = EintippenArabischDirekt(document.getElementById('eingabeSucheArabischEdit').value);		
        	
        if (document.activeElement.id == 'eingabeSucheEdit')
        {
            document.getElementById('eingabeSucheDeutschEdit').value = '';
            document.getElementById('eingabeSucheArabischEdit').value = '';		
            document.getElementById('SucheAbsendenEdit').value = document.getElementById('eingabeSucheEdit').value;
        }
        if (document.activeElement.id == 'eingabeSucheDeutschEdit')
        {
            document.getElementById('eingabeSucheEdit').value = '';
            document.getElementById('eingabeSucheArabischEdit').value = '';		
        }
        if (document.activeElement.id == 'eingabeSucheArabischEdit')
        {
            document.getElementById('eingabeSucheDeutschEdit').value = '';
            document.getElementById('eingabeSucheEdit').value = '';
            document.getElementById('SucheAbsendenEdit').value = document.getElementById('eingabeSucheArabischEdit').value;
        }
        if ((event.keyCode==13) && (event.target))
        {
            var el=event.target;
            while ((el != null) && (el.tagName != 'FORM'))
                el = el.parentNode; // so lange nach oben gehen, bis ein Formular gefunden wird
            if (el)
                el.submit();
        }
}*/